export class AppFrontRoutes {

    public static LOGIN = 'login';
    public static DASHBOARD = 'dashboard';
    public static PROFILE = 'profile';
    public static SETTINGS = 'settings';
    public static TICKET_LIST = 'ticket/list';
    public static TICKET_CREATE = 'ticket/create';
    public static TICKET_VIEW = 'ticket/view';

    //Deadline routes
    public static Deadline_List = 'deadline/list';
    public static DEADLINE_VIEW = 'deadline/view';
    public static DEADLINE_VIEWLIST = 'deadline/view/$';

    //Servicing routes
    public static Servicing_List = 'servicing/list';
    public static Servicing_Create = 'servicing/create';
    public static SERVICING_VIEW = 'servicing/single_view';
    public static MAINTENANCE_PLANS = 'servicing/maintenance_plans';

    //Human Resources Routes
    public static Notification_List = 'course/notification';
    public static ADD_NOTIFICATION = 'course/add_notification';
    public static EDIT_NOTIFICATION = 'course/edit_notification';
    public static NOTIFICATION_VIEW = 'course/notification_view';

    public static MEDICAL_EXAMINATION = 'course/medical_examination';
    public static NEW_EXAMINATION     = 'course/new_examination';
    public static EDIT_EXAMINATION    = 'course/edit_examination';
    public static EXAMINATION_VIEW    = 'course/examination_view';


    public static SKILLS_COURSE_LIST = 'course/skills_view';
    public static SKILLS_LIST = 'course/skills_list';
    public static EMPLOYEE_LIST = 'course/employee_list';
    public static EMPLOYEE_VIEW = 'course/employee_view';


    public static CREATE_COURSE = 'course/create_course';
    public static UPDATE = 'course/update';


    public static MEASUREMENT = 'measurement';
    public static CREATE = 'measurement/create';
    public static EDIT = 'measurement/edit';
    public static SINGLE_VIEW = 'measurement/single_view';

    public static CALIBRATION_PLANS = 'measurement/calibration_plans';
    public static PROBLEM_SOLVING = 'problem-solving';
    public static VIEW_PROBLEM_DETAILS = 'problem-solving/view-problem-details';
    public static DOCUMENT_MANAGEMENT = 'documents_mang';


    public static DOCUMENTMANG_VIEW = 'documents_mang/view';
    public static CUSTOMERS = 'customers';
    public static CUSTOMERS_VIEW = 'customers/single_view';

    public static CREATE_CUSTOMER = 'customers/create';
    public static EDIT_CUSTOMER = 'customers/edit';

    public static SUPPLYERS = 'supplyers';
    public static SUPPLYERS_VIEW = 'supplyers/single_view';

    public static CONSULTANCY = 'consultancy';
    public static CREATE_CONSULTANCY = 'consultancy/create';
    public static EDIT_CONSULTANCY = 'consultancy/edit';
    public static CONSULTANCY_VIEW = 'consultancy/single_view';
    public static REPORTING = 'consultancy/reporting';

    public static SCHEDULEDCOURSES = 'academy/scheduled_course';
    public static CREATE_SCHEDULE_COURSE = 'academy/create_schedule_course';
    public static SCHEDULED_COURSE_VIEW = 'academy/scheduled_course_view';


    public static ADMIN_TICKET_LIST = 'admin_ticket';
    public static ADMIN_TICKET_VIEW = 'admin_ticket/view';

    public static ADMIN_MAIL_CONFIG = 'mail_config';
    public static COURSE_CATELOG = 'academy/view_catelog';
    public static COURSE_CATALOG_VIEW = 'academy/catalog_view';
    public static QUALIFIED_TEACHER = 'academy/qualified_teacher';
    public static QUALIFIED_TEACHER_CREATE = 'academy/create_teacher';
    public static QUALIFIED_TEACHER_EDIT = 'academy/edit_qualified_data';
    public static QUALIFIED_TEACHER_VIEW = 'academy/qualified_teacher_view';

    public static PROJECT = 'project';
    public static PROJECT_VIEW = 'project/view';
    public static PROJECT_CLASS = 'project/classes';
    public static PROJECT_REPORTING = 'project/reporting';

    public static AUDIT_LIST = 'audit';
    public static AUDIT_VIEW = 'audit/audit_view';
    public static STANDARD = 'audit/standard';

    public static INSTALLATION_LIST = 'installation_list';
    public static CREATE_INSTALLATION = 'installation';
    public static SUPER_USER_DETAILS = "user_details"
    public static SDASHBOARD = 'sdashboard';
    public static SUPERADMIN = 'superAdmin';
    public static SUPER_LANG = 'lang';
    public static SUPER_ADMIN_MAIL_CONFIG = 'mail_config';
    public static ADMIN_PACKAGE_LIST = 'package';
    public static PRIVACY_TREATMENT_REGISTER = 'privacy/treatment_register';
    public static PRIVACY_APPOINTMENT_REGISTER = 'privacy/appointment_register';
    public static CALENDAR = 'calendar';
    
    
    


}
